import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Check } from 'lucide-react';
export function Guarantee() {
  return <section className="py-24 lg:py-32 bg-paper-alt" data-id="element-84">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-85">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="bg-paper-card rounded-[24px] p-10 md:p-16 text-center shadow-sm border border-paper-border relative overflow-hidden" data-id="element-86">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-96 h-96 bg-brand-50/50 rounded-full blur-3xl pointer-events-none" data-id="element-87"></div>

          <div className="relative z-10" data-id="element-88">
            <div className="w-20 h-20 mx-auto bg-brand-50 text-brand-500 rounded-full flex items-center justify-center mb-8" data-id="element-89">
              <ShieldCheck className="w-10 h-10" strokeWidth={1.5} data-id="element-90" />
            </div>

            <div className="inline-block text-terra-600 font-medium text-xs uppercase tracking-widest mb-4 px-4 py-1.5 bg-terra-50 rounded-full border border-terra-100" data-id="element-91">
              Compra protegida
            </div>

            <h2 className="text-3xl md:text-5xl font-serif font-medium text-ink-800 mb-6 leading-tight tracking-tight" data-id="element-92">
              Probalo durante{' '}
              <span className="text-brand-500" data-id="element-93">7 días sin riesgo</span>
            </h2>

            <p className="text-lg md:text-xl text-ink-600 mb-10 max-w-2xl mx-auto leading-relaxed font-normal" data-id="element-94">
              Si sentís que no es para vos, te devolvemos el{' '}
              <strong className="text-ink-800 font-medium" data-id="element-95">
                100% de tu dinero
              </strong>
              . Sin preguntas, sin vueltas, sin letra chica.
            </p>

            <div className="flex flex-wrap justify-center gap-4" data-id="element-96">
              {['Sin preguntas', 'Sin vueltas', 'Sin letra chica'].map((t, i) => <div key={i} className="flex items-center gap-3 bg-paper-main px-5 py-2.5 rounded-full text-sm font-medium text-ink-800 border border-paper-border" data-id="element-97">
                    <Check className="w-4 h-4 text-brand-500" strokeWidth={2} data-id="element-98" />{' '}
                    {t}
                  </div>)}
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}